@if (realmLoading()) {
    <div class="card">
        <div class="mb-4">
            <p-skeleton width="100%" height="3.5rem" />
        </div>
        <div class="flex flex-col gap-4">
            <p-skeleton width="60%" height="2rem" />
            <div class="flex gap-3">
                @for (_ of [1,2,3,4,5,6]; track $index) {
                    <p-skeleton width="6rem" height="2.5rem" />
                }
            </div>
            <p-skeleton width="100%" height="1rem" />
            <p-skeleton width="40%" height="2.5rem" />
            <p-skeleton width="100%" height="2.5rem" />
            <p-skeleton width="100%" height="2.5rem" />
        </div>
    </div>
} @else if (selectedRealm() === null) {
    <app-website-list></app-website-list>
} @else {
    <app-website-info
        #websiteInfo
        [realm]="selectedRealm()"
        [providerStatus]="selectedProviderStatus()"
        (close)="backToList()"
        (realmReassigned)="onRealmReassigned($event)"
    ></app-website-info>
}

<p-dialog
    header="Unsaved Changes"
    [visible]="unsavedDialogVisible()"
    (visibleChange)="onDialogCancel()"
    [style]="{ width: '28rem' }"
    [modal]="true"
    [closable]="true"
>
    <div class="flex items-center gap-3">
        <i class="pi pi-exclamation-triangle text-3xl" style="color: var(--p-orange-500)"></i>
        <span>You have unsaved changes. What would you like to do?</span>
    </div>
    <ng-template #footer>
        <div class="flex justify-end gap-2">
            <p-button label="Cancel" severity="secondary" (onClick)="onDialogCancel()"></p-button>
            <p-button label="Discard" severity="danger" icon="pi pi-trash" (onClick)="onDialogDiscard()"></p-button>
            <p-button label="Save" icon="pi pi-check" (onClick)="onDialogSave()"></p-button>
        </div>
    </ng-template>
</p-dialog>
